import { PrimaryButton } from "@loanbossinc/component-library";
import styled from "styled-components/macro";

export const InputWrapper = styled.div`
  && {
    margin-bottom: 1em;
    width: 100%;
  }
`;

export const ControlRow = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0.5em;
  }
`;

export const ControlRowItem = styled.div`
  && {
    padding: 0 0.5em;
    width: 100%;
  }
`;

export const SectionWrapper = styled.div`
  && {
    align-items: flex-start;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    display: flex;
  }
`;

export const LeftSectionWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    justify-content: center;
    padding-left: 0.5em;
    width: 50%;
  }
`;

export const HousesIconWrapper = styled.div`
  && {
    padding-left: 0.6em;
  }
`;

export const RightSectionWrapper = styled.div`
  && {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    padding-left: 0.5em;
    width: 50%;
  }
`;

export const DescriptionWrapper = styled.div`
  && {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    padding-right: 0.7em;
  }
`;

export const PaddedWrapper = styled.div`
  && {
    padding: ${props => props.padding || "0 1.5em"};
  }
`;

export const StyledSelectButton = styled(PrimaryButton)`
  width: 121px !important;
  height: 36px !important;
  background-color: #005aa9 !important;
  font-size: 14px !important;
`;

export const Row = styled.div`
  align-items: center;
  background: #ffffff;
  border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
  box-sizing: border-box;
  display: flex;
  min-height: 68px;
  justify-content: ${props => props.justifyContent || "space-between"};
  width: 100%;

  & ${StyledSelectButton} {
    display: none;
  }

  &:hover {
    background: ${props => props.background || "#fafafa"};
    & ${StyledSelectButton} {
      display: ${props => (props.showSelect ? "initial" : "none")};
    }
  }
`;

export const FieldNameWrapper = styled.div`
  && {
    color: #5f6368;
    font-family: Work Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    min-width: 225px;
    text-transform: uppercase;
  }
`;

export const FieldDataWrapper = styled.div`
  && {
    color: black;
    font-family: Roboto Mono;
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 21px;
    text-transform: uppercase;
  }
`;

export const SelectButtonWrapper = styled.div`
  && {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    padding-left: 100px;
    padding-right: 17px;
  }
`;

export const NoiFieldDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 3em;
`;

export const NoiReportNameWrapper = styled.div`
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
  padding-top: 0.5em;
`;
